import { inject } from '@angular/core';
import { SessionService } from '../services/session.service';

export const expiredGuard = () => {
	const sessionService: SessionService = inject(SessionService);
	return sessionService.hasExpired$.asObservable();
}